import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { CreditLeasingSingle } from './types';

export function useCreditLeasingSingleData(): Page<CreditLeasingSingle> {
  return useCurrentPage<Page<CreditLeasingSingle>>();
}
